import type { OrganizationSummary } from '../../organizations/lib/types'
import type { ApprovalOverview } from './types'

export function buildDemoApprovalOverview(organization: OrganizationSummary | null): ApprovalOverview {
  const companyName = organization?.name ?? 'Dein Unternehmen'

  const items = [
    {
      id: 'approval-1',
      contentItemId: 'content-approval-1',
      title: `${companyName}: Kundenprojekt mit klarer Terminzusage`,
      channel: 'LinkedIn',
      contentType: 'social_post' as const,
      status: 'pending' as const,
      contentStatus: 'in_review' as const,
      scheduledFor: '2026-04-28T09:00:00.000Z',
      dueAt: '2026-04-27T12:00:00.000Z',
      comment: 'Starker Proof-Punkt fuer Verlaesslichkeit und Fertigungsqualitaet.',
      requestedFromUserId: 'demo-approver-1',
      assigneeLabel: 'Julia Freigabe',
    },
    {
      id: 'approval-2',
      contentItemId: 'content-approval-2',
      title: 'Monatsnewsletter mit zwei Referenzen und einer Maschinen-Neuigkeit',
      channel: 'Newsletter',
      contentType: 'newsletter' as const,
      status: 'pending' as const,
      contentStatus: 'in_review' as const,
      scheduledFor: '2026-04-29T07:30:00.000Z',
      dueAt: '2026-04-28T17:00:00.000Z',
      comment: 'Betreffzeile A/B-Test ist vorbereitet.',
      requestedFromUserId: 'demo-approver-2',
      assigneeLabel: 'Max Vertrieb',
    },
    {
      id: 'approval-3',
      contentItemId: 'content-approval-3',
      title: 'Recruiting-Post zur Werkstattkultur',
      channel: 'Instagram',
      contentType: 'social_post' as const,
      status: 'changes_requested' as const,
      contentStatus: 'draft' as const,
      scheduledFor: null,
      dueAt: null,
      comment: 'Mehr Alltag, weniger Agentur-Sprache.',
      requestedFromUserId: null,
      assigneeLabel: 'Nicht zugewiesen',
    },
    {
      id: 'approval-4',
      contentItemId: 'content-approval-4',
      title: 'LinkedIn-Post zum Branchenmythos',
      channel: 'LinkedIn',
      contentType: 'social_post' as const,
      status: 'approved' as const,
      contentStatus: 'scheduled' as const,
      scheduledFor: '2026-04-30T10:30:00.000Z',
      dueAt: null,
      comment: null,
      requestedFromUserId: 'demo-approver-1',
      assigneeLabel: 'Julia Freigabe',
    },
  ]

  const now = Date.now()
  const overdueCount = items.filter(
    (item) => item.status === 'pending' && item.dueAt && new Date(item.dueAt).getTime() < now,
  ).length

  return {
    pendingCount: items.filter((item) => item.status === 'pending').length,
    approvedCount: items.filter((item) => item.status === 'approved').length,
    changesRequestedCount: items.filter((item) => item.status === 'changes_requested').length,
    overdueCount,
    items,
  }
}